import React from "react";
import BulkBookUpload from "../../components/AdminTabs/AdminBookSearch/BulkBookUpload";

const BulkBookUploadPage = () => {
  return (
    <div>
      <BulkBookUpload />
    </div>
  );
};

export default BulkBookUploadPage;
